<template>
  <div style="width: 100%;">
    <div v-if="tagIdData.length > 0">
      <p class="input-name">{{api}}</p>
      <div :class="api!=='character'? 'decide-border': ''" class="decideContent-wrapper">
        <p v-for="(val, key) in tagNameData" class="decideContent">
          {{val}} <span class="batu" @click="deleteItem(key)">×</span>
        </p>
      </div>
    </div>
    <slot></slot>

    <!-- 変換予測候補を表示するとこ -->
    <div class="tag-candidate-wrapper" v-if="tagName.length > 0 || isFocusItemCategory">
      <loading class="taginput-loading" w="50" h="50" v-if="isLoading"></loading>
      <div v-else>
        <div v-for="(val, key) in candidates" class="tag-candidate">
          <p class="tag-span" v-if="val.hasOwnProperty('anime_tag')" @click="selectItem(val.tag)">{{tagLangFilter(val.tag)}}
            <span class="anime-name" v-if="api === 'character'">-{{val.anime_tag != null ? tagLangFilter(val.anime_tag) : ''}}</span>
          </p>
          <p class="tag-span" v-else @click="selectItem(val)">{{tagLangFilter(val)}}</p>
        </div>
      </div>
      <p clas="tag-candidate" @click="isModal=true">{{lang[0]}}</p>
    </div>

    <!-- 新規作成モーダル   -->
    <modal @close="isModal=false" v-if="isModal">
      <div v-if="api === 'character'">
        <h4>{{lang[1]}}</h4>
        <p class="left">{{lang[2]}}: {{tagName}}</p>
        <p class="left">{{lang[3]}}: {{decideAnime.length>1 ? tagLangFilter(decideAnime) : anime}}</p>
        <p>{{lang[4]}}</p>
        <p class="validate">{{ers.anime}}</p>
        <n-input type="text" v-model="anime" @input="animeSearch" class="anime-input"></n-input>
        <div class="tag-candidate-wrapper" v-if="animeList.length > 0">
          <p v-for="(val, key) in animeList" class="tag-candidate" @click="selectAnime(val)">
            {{tagLangFilter(val)}}
          </p>
        </div>
      </div>
      <div v-else>
        <h4 class="text-center"> {{lang[5]}} {{checkLang()}} {{lang[6]}} </h4>
        <p class="text-center">
          <n-input type="text" v-model="tagName" :placeholder="lang[10]" class="m-t-20"></n-input>
        </p>
      </div>
      <div class="btn-wrapper">
        <btn type="cancel" size="normal" :label="lang[8]"  @click="isModal=false"></btn>
        <btn v-if="api==='character' && !anime || !tagName" type="normal" size="normal" :label="lang[9]"></btn>
        <btn v-else  type="primary" size="normal" :label="lang[9]" :loading="loading" @click="createItem"></btn>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'
import Modal from './Modal.vue'
import Btn from './Button.vue'
import NInput from './Input.vue'
import Loading from './Loading.vue'
import TagInputLangMaster from '../masters/langMaster/TagInputLangMaster'

export default {
  neme: 'TagInput',
  props: {
    tagNameData: {type: Array},
    tagIdData: {type: [Array, Number]},
    api: {type: String},
    validate: {type: String},
  },

  components: {
    Btn,
    Modal,
    NInput,
    Loading,
  },

  data() {
    return {
      lang: TagInputLangMaster[this.$store.state.account.lang],
      isNewTagCreate: false,
      candidates: [],
      loading: false,
      anime: '',
      decideAnime: {},
      animeList: [],
      isModal: false,
      tagName: '',
      isLoading: false,
      isFocusItemCategory: false,
      ers: {
        anime: "",
      },
    };
  },

  watch: {
    anime() {
      if(this.anime.length === 0 || this.decideAnime.length > 0) {
        this.animeList = ''
      }
    }
  },

  methods: {
    getCandidates(name) {
      if(name && !name.match(/^\s/g)) {
        this.isLoading = true
        this.isFocusItemCategory = false,
        this.tagName = name
        let encodeText = encodeURIComponent(this.tagName)
        axios.get(`/private/${this.api}/${encodeText}`).then(data => {
          this.candidates = data.data.model
          this.isFocusItemCategory = false,
          this.isLoading = false
        }).catch(err => {
        })
      }
    },

    getItemCategory() {
      this.isLoading = true
      axios.get('private/item_category').then(data => {
        this.candidates = data.data.model
        this.isLoading = false
        this.isFocusItemCategory = true
      }).catch(err => {
        console.log(err);
      })
    },

    animeSearch() {
      this.decideAnime = {}
      if(this.anime === '') return false
      let encodeText = encodeURIComponent(this.anime)
      axios.get(`/private/content_title/${encodeText}`).then(data => {
        this.animeList = data.data.model
      }).catch(err => {
        console.log(err)
        this.animeList = ''
      })
    },

    selectAnime(val) {
      this.decideAnime = val
      this.anime = this.tagLangFilter(val)
    },

    selectItem(val) {
      //重複チェック
      if(this.candidates.find(item => item === val.id)) {
        return false
      } else {
        this.tagIdData.push(val.id)
        this.tagNameData.push(this.tagLangFilter(val))
        this.$emit('nullCheckVal')
        this.tagName = ''
        this.isFocusItemCategory = false
      }
    },

    deleteItem(key) {
      this.tagIdData.splice(key, 1)
      this.tagNameData.splice(key, 1)
      this.$emit('nullCheckVal')
    },

    createItem() {
      this.loading = true
      let obj = {
        [this.$store.state.account.lang]: this.tagName
      }
      if(this.api === 'character' && this.decideAnime.id) {
        obj.anime_id = this.decideAnime.id
        this.sendItem(obj)
        this.decideAnime = {}
        this.anime = ''
      } else if (this.api === 'character' && !this.decideAnime.id) {
        axios.post(`private/content_title`, {[this.$store.state.account.lang]: this.anime}).then(data => {
          obj.anime_id = data.data.model.id
          this.sendItem(obj)
          this.anime = ''
        })
      } else {
        this.sendItem(obj)
      }
    },

    sendItem(obj) {
      axios.post(`private/${this.api}`,obj).then(data => {
        this.loading = false
        this.isModal = false
        this.tagIdData.push(data.data.model.id)
        this.tagNameData.push(data.data.model[this.$store.state.account.lang])
        this.$emit('resetForm')
        this.tagName = ''
      })
    },

    animeSwitch() {
      this.isNewTagCreate = true
      this.$emit('animeSwitch', true)
    },

    checkLang() {
      return this.lang[7].api[this.api]
    },

    tagLangFilter(val) {
      //優先度の高い言語順の配列作成(重複しても問題ない)
      let priorityArr = [this.$store.state.account.lang, 'ja', 'en']
      let tag = ''
      for (let i = 0; i<3; i++) {
        if(val[priorityArr[i]] !== null) {
          tag = val[priorityArr[i]]
          break
        }
      }
      return tag
    }
  }

}
</script>

<style scoped>
.tag-candidate-wrapper {
  max-width: 100%;
  max-height: 150px;
  min-height: 50px;
  height: fit-content;
  padding: 10px;
  border: 1px solid #bfbfbf;
  text-align: left;
  overflow: scroll;
  font-size: 14px;
  position: relative;
}

.tag-candidate {
  margin-bottom: 0.3rem!important;
  border-bottom: 1px solid #e8e3e3;
  padding: 0px 5px;
  white-space: nowrap;
}

.tag-span {
  display: block;
  width: 100%;
  margin-bottom: 0.5rem!important;
}

.anime-name {
  font-size: 12px;
  color: #888;
}

.decideContent-wrapper {
  margin: auto;
  display: flex;
  flex-wrap: wrap;
}

.decide-border {
  border-bottom: 1px solid #868686;
}

.decideContent {
  padding: 5px 10px;
  background: #58acfa;
  color: #fff;
  font-size: 14px;
  margin-bottom: 5px!important;
  width: fit-content;
  margin-right: 5px;
}

.left {
  text-align: left;
  margin-left: 15px;
}

.anime-input {
  width: 80%;
  margin: 20px auto;
}

.taginput-loading {
  width: 50px;
  height: 50px;
  margin: auto;
}

.input-name {
  font-size: 12px;
  line-height: 0;
  margin-block-end: 0px;
  margin-bottom: 10px!important;
  margin-left: 5px;
  color: #515659;
  font-weight: bold;
}

</style>
